export const environment = {
  production: true,
  name: 'prod',
   configFile: 'assets/config/app.config.json'

};
